import { createApiRef } from '@backstage/frontend-plugin-api';
import type { RecommendedDocEntry, TeamRecommendedDocs } from './types';

export interface RecommendedDocsApi {
  getCompany(): Promise<RecommendedDocEntry[]>;
  setCompany(entries: RecommendedDocEntry[]): Promise<void>;
  getTeams(teamRefs: string[]): Promise<TeamRecommendedDocs>;
  getTeam(teamRef: string): Promise<RecommendedDocEntry[]>;
  setTeam(teamRef: string, entries: RecommendedDocEntry[]): Promise<void>;
}

export const recommendedDocsApiRef = createApiRef<RecommendedDocsApi>().with({
  id: 'recommended-docs',
  pluginId: 'app',
});
